import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cancel-export-overlay" }

import ConfirmDialog from '@/components/common/ConfirmDialog.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CancelExportOverlay',
  emits: ["confirm", "cancel"],
  setup(__props, { emit: emits }: { emit: ({
  (event: 'confirm'): void,
  (event: 'cancel'): void,
}), expose: any, slots: any, attrs: any }) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ConfirmDialog, {
      class: "cancel-export-overlay__confirm-dialog",
      message: "Are you sure you want to stop the export process?",
      confirmText: "Yes",
      cancelText: "Cancel",
      onConfirm: _cache[0] || (_cache[0] = ($event: any) => (emits('confirm'))),
      onCancel: _cache[1] || (_cache[1] = ($event: any) => (emits('cancel')))
    })
  ]))
}
}

})